import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

// Use relative URL on web to leverage webpack proxy (handles CORS), full URL on native
//const API_BASE_URL = Platform.OS === 'web' ? '' : 'https://acestreamz.com';
const API_BASE_URL = 'https://acestreamz.com';

// reCAPTCHA v2 site key. Set to the public site key that matches Laravel's RECAPTCHA_SECRET_KEY.
// Leave empty to disable the widget (backend will not enforce when Laravel has no secret key set).
// Web-only; native builds ignore it unless a native captcha package is installed.
//
// Auto-disable on local dev (localhost / RFC1918 LAN IPs). The production site key
// only allows acestreamz.com / webapp.acestreamz.com — anywhere else Google returns
// "Invalid domain for site key". Empty key skips the widget entirely.
const RECAPTCHA_PROD_KEY = '6LdaOMQsAAAAAEGYzbZ_5oszsTatYhYbBBpxdae1';
const isLocalDev = typeof window !== 'undefined' && window.location && (
  /^(localhost|127\.0\.0\.1|::1)$/.test(window.location.hostname) ||
  /^192\.168\.\d+\.\d+$/.test(window.location.hostname) ||
  /^10\.\d+\.\d+\.\d+$/.test(window.location.hostname) ||
  /^172\.(1[6-9]|2[0-9]|3[01])\.\d+\.\d+$/.test(window.location.hostname)
);
const RECAPTCHA_SITE_KEY = isLocalDev ? '' : RECAPTCHA_PROD_KEY;

//const ENDPOINTS = {
//
//  AUTH: {
//    LOGIN: '/api/login',
//  },
//    REGISTER: '/mobile/signup/register',
//    TERMS: '/api/terms',
//    WELCOME_SCREEN: '/api/home_screen',
//    PROFILE : '/api/mobile/profile',
//    ONLINE_USERS: '/api/mobile/online-users',
//    COIN_HISTORY : '/mobile/coins-history',
//    OTP_VERIFICATION : '/mobile/signup/verify-otp',
//    RESEND_OTP : '/mobile/signup/resend-otp',
//    SETUP_PROFILE_IMAGE : '/mobile/signup/setup-profile',
//    FORGOT_PASSWORD : '/mobile/forgot-password',
//    OTP_FORGOT_PASSWORD : '/mobile/verify-forgot-password-otp',
//    RESET_PASSWORD : '/mobile/reset-password',
//    CHANGE_PASSWORD : '/mobile/mobile/change-password',
//    UPDATE_PROFILE : '/mobile/profile_edit',
//    // Ensure leading slash so it resolves relative to baseURL
//    LIVE_STREAMING_LIST : '/api/mobile/list',
//    APPLE_SOCIAL_LOGIN : '/api/signup/apple',
//    GOOGLE_SOCIAL_LOGIN : '/api/signup/google',
//    WALLET : '/api/mobile/wallet',
//    GET_NOTIFICATION_LIST : '/api/mobile/notifications',
//    NOTIFICATION_READ : '/api/mobile/notifications/mark-all-read',
//    // Dynamic delete endpoint for a specific notification by id
//    DELETE_SPECIFIC_NOTIFICATION: (id) => `/api/mobile/notifications/${id}`,
//    CLEAR_ALL_NOTIFICAITON : '/api/mobile/notifications/clear-all',
//
//    GIFT_SEND : '/api/mobile/gift-send',
//    FOLLOWERS_LIST : '/api/mobile/followers_list',
//    FOLLOWING_LIST : '/api/mobile/following_list',
//    GET_USER_INFO: '/api/mobile/get_user_by_id',
//    CREDIT_COIN : '/api/mobile/credit-coin',
//    GIFT_LIST : '/api/mobile/gifts',
//
//    FOLLOW_ACCOUNT : '/api/mobile/follow',
//    UNFOLLOW_ACCOUNT : '/api/mobile/unfollow',
//
//
//    LIVE_STREAMING_START : '/api/mobile/start',
//    LIVE_STREAMING_STOP : '/api/mobile/stop',
//    JOIN_STREAMING : '/api/mobile/livestreams/0/join',
//
//    SEND_MESSAGE : '/api/mobile/chat/send-message',
//    MARK_READ_MESSAGE : '/api/mobile/chat/rooms/1/mark-read',
//    GET_CHAT : '/api/mobile/chat/rooms',
//
//    GIFT_SEND : '/api/mobile/gift-send',
//    SUBSCRIPTION_PLANS:'/api/mobile/subscription/plans',
//    SUBSCRIPTION_STATUS:'/api/mobile/subscription/status',
//    SUBSCRIPTION_CANCEL: '/api/mobile/subscription/cancel',
//    START_TRIAL_PLAN:'/api/mobile/subscription/trial/start',
//    PURCHASE_SUBSCRIPTION:'/api/mobile/subscription/purchase',
//
//    TOKEN_GENERATE :'/api/token-link/generate',
//    VERIFY_IAP: '/api/mobile/iap/verify',
//    COINS_BUY :'/api/mobile/coins',
//    // Correct redeem endpoint (keep legacy key for compatibility)
//    REDEEM: '/api/mobile/redeem',
//    REDEEMPTION_HISTORY : '/api/mobile/redemption-history',
//    CATEGORIES : '/api/mobile/categories',
//    // KYC
//    KYC_INITIATE: '/mobile/kyc/initiate',
//};

const ENDPOINTS = {

  AUTH: {
    LOGIN: '/mobile/login',
    LOGOUT: '/mobile/logout',
    LOGOUT_ALL: '/mobile/logout-all',
    TWO_FA_VERIFY_LOGIN: '/mobile/2fa/verify-login',
    TWO_FA_ENABLE: '/mobile/2fa/enable',
    TWO_FA_CONFIRM: '/mobile/2fa/confirm',
    TWO_FA_DISABLE: '/mobile/2fa/disable',
  },
    REGISTER: '/mobile/signup/register',
    TERMS: '/mobile/terms',
    PRIVACY: '/mobile/legal/privacy',
    WELCOME_SCREEN: '/mobile/home_screen',
    PROFILE : '/mobile/profile',
    ONLINE_USERS: '/mobile/online-users',
    COIN_HISTORY : '/mobile/coins-history',
    OTP_VERIFICATION : '/mobile/signup/verify-otp',
    RESEND_OTP : '/mobile/signup/resend-otp',
    SETUP_PROFILE_IMAGE : '/mobile/signup/setup-profile',
    FORGOT_PASSWORD : '/mobile/forgot-password',
    OTP_FORGOT_PASSWORD : '/mobile/verify-forgot-password-otp',
    RESET_PASSWORD : '/mobile/reset-password',
    CHANGE_PASSWORD : '/mobile/change-password',
    UPDATE_PROFILE : '/mobile/profile_edit',
    // Ensure leading slash so it resolves relative to baseURL
    LIVE_STREAMING_LIST : '/mobile/list',
    APPLE_SOCIAL_LOGIN : '/mobile/signup/apple',
    GOOGLE_SOCIAL_LOGIN : '/mobile/signup/google',
    WALLET : '/mobile/wallet',
    GET_NOTIFICATION_LIST : '/mobile/notifications',
    NOTIFICATION_READ : '/mobile/notifications/mark-all-read',
    // Dynamic delete endpoint for a specific notification by id
    DELETE_SPECIFIC_NOTIFICATION: (id) => `/mobile/notifications/${id}`,
    CLEAR_ALL_NOTIFICAITON : '/mobile/notifications/clear-all',

    GIFT_SEND : '/mobile/gift-send',
    FOLLOWERS_LIST : '/mobile/followers_list',
    FOLLOWING_LIST : '/mobile/following_list',
    GET_USER_INFO: '/mobile/get_user_by_id',
    CREDIT_COIN : '/mobile/credit-coin',
    GIFT_LIST : '/mobile/gifts',

    FOLLOW_ACCOUNT : '/mobile/follow',
    UNFOLLOW_ACCOUNT : '/mobile/unfollow',


    LIVE_STREAMING_START : '/mobile/start',
    LIVE_STREAMING_STOP : '/mobile/stop',
    JOIN_STREAMING : (streamId) => `/mobile/livestreams/${streamId}/join`,
    // Host-only keepalive to prevent zombie streams. Body { id } optional; the
    // backend resolves the user's active stream when id is omitted.
    LIVE_STREAMING_HEARTBEAT : '/mobile/heartbeat',

    SEND_MESSAGE : '/mobile/chat/send-message',
    SEND_PRIVATE_MESSAGE: '/mobile/chat/unified/private/send',
    GET_MESSAGES: (roomIdentifier) => `/mobile/chat/unified/messages/${roomIdentifier}`,
    // Unified mark-read. The old `/mobile/chat/rooms/{roomId}/mark-read` path
    // 404s ("Room not found or unauthorized") for unified room UUIDs, so unread
    // counts never cleared. Verified against the backend: this unified route
    // returns 200 { status, unread_count: 0 }.
    MARK_READ_MESSAGE : (roomId) => `/mobile/chat/unified/mark-read/${roomId}`,
    GET_CHAT : '/mobile/chat/rooms',
    GET_CHAT1 : '/mobile/chat/unified/rooms',

    SUBSCRIPTION_PLANS:'/mobile/subscription/plans',
    SUBSCRIPTION_STATUS:'/mobile/subscription/status',
    SUBSCRIPTION_CANCEL: '/mobile/subscription/cancel',
    START_TRIAL_PLAN:'/mobile/subscription/trial/start',
    PURCHASE_SUBSCRIPTION:'/mobile/subscription/purchase',

    TOKEN_GENERATE :'/api/token-link/generate',
    VERIFY_IAP: '/mobile/iap/verify',
    COINS_LIST: '/mobile/coins',           // GET - List available coin packages
    COINS_BUY: '/mobile/credit-coin',      // POST - Purchase/credit coins
    REDEEM: '/mobile/redeem',
    REDEEMPTION_HISTORY : '/mobile/redemption-history',
    CATEGORIES : '/mobile/categories',
    // KYC
    KYC_INITIATE: '/mobile/kyc/initiate',
    // Platform Accounts
    PLATFORMS: '/mobile/platforms',
    PLATFORM_ACCOUNT: '/mobile/platform-account',
    PLATFORM_ACCOUNTS: '/mobile/platform-accounts',
    UPDATE_PLATFORM_ACCOUNT: (id) => `/mobile/platform-account/${id}`,
    DELETE_PLATFORM_ACCOUNT: (id) => `/mobile/platform-account/${id}`,
    PLATFORM_CREDIT_COIN: '/mobile/credit-coin',
    // Transfer Coins
    TRANSFER_COINS: '/mobile/transfers',

    // Card Management
    CARDS: '/mobile/cards',
    CARD_DELETE: (id) => `/mobile/cards/${id}`,

    // Unified Coin Purchase
    PURCHASE_COINS: '/mobile/purchase-coins',
    PURCHASE_HISTORY: '/mobile/coins/purchase-history',
    // Crypto payment status (NowPayments) tracking by purchase id
    PURCHASE_STATUS: (purchaseId) => `/mobile/purchase-coins/${purchaseId}/status`,

    // Live Streaming
    VIEW_COUNT: '/mobile/viewcount',

    // Home banner carousel (public, no auth required)
    SLIDES: '/mobile/slides',
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request Interceptor: Add Authorization token and log requests
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await AsyncStorage.getItem('userToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Forward user's preferred language so backend SetLocale middleware can honour it
    const lang = await AsyncStorage.getItem('language_preference');
    if (lang) {
      config.headers['X-Language'] = lang;
    }
    if (__DEV__) {
      console.log('🌐 [API REQUEST]', config.method?.toUpperCase(), config.baseURL + config.url);
      console.log('📤 [REQUEST HEADERS]', JSON.stringify(config.headers, null, 2));
      if (config.data) {
        console.log('📦 [REQUEST BODY]', JSON.stringify(config.data, null, 2));
      }
      if (config.params) {
        console.log('🔍 [REQUEST PARAMS]', JSON.stringify(config.params, null, 2));
      }
    }
    return config;
  },
  (error) => {
    if (__DEV__) {
      console.log('❌ [REQUEST ERROR]', error.message);
    }
    return Promise.reject(error);
  }
);

// Shape a consistent error object for the app
function mapAxiosError(err) {
  const base = {
    code: 'UNKNOWN',
    message: 'Something went wrong',
    status: undefined,
    retryable: false,
    details: undefined,
  };

  // Timeout / network-level errors
  if (err.code === 'ECONNABORTED') {
    return { ...base, code: 'TIMEOUT', message: 'Request timed out', retryable: true };
  }

  if (err.response) {
    const { status, data } = err.response || {};
    const serverMsg = (data && (data.message || data.error || data.msg)) || '';
    // Backend sometimes puts structured error context under `data.data` (Laravel)
    // and sometimes under `data.errors` / `data.details`. Expose whichever is present
    // so callers can read fields like kyc_required, available_balance, etc.
    const details = (data && (data.errors || data.details || (data.data && typeof data.data === 'object' ? data.data : undefined))) || undefined;

    const mapped = { ...base, status, details };

    switch (status) {
      case 400:
        return { ...mapped, code: 'HTTP_400', message: serverMsg || 'Bad request' };
      case 401:
        return { ...mapped, code: 'HTTP_401', message: serverMsg || 'Unauthorized' };
      case 403:
        return { ...mapped, code: 'HTTP_403', message: serverMsg || 'Forbidden' };
      case 404:
        return { ...mapped, code: 'HTTP_404', message: serverMsg || 'Not found' };
      case 409:
        return { ...mapped, code: 'HTTP_409', message: serverMsg || 'Conflict' };
      case 422:
        return { ...mapped, code: 'HTTP_422', message: serverMsg || 'Validation failed', details };
      case 429:
        return { ...mapped, code: 'HTTP_429', message: serverMsg || 'Too many requests', retryable: true };
      default:
        return {
          ...mapped,
          code: `HTTP_${status}`,
          message: serverMsg || 'Request failed',
          retryable: status >= 500,
        };
    }
  }

  if (err.request) {
    return { ...base, code: 'NETWORK', message: 'No response from server', retryable: true };
  }

  return { ...base, message: err.message || base.message };
}

// Response Interceptor: Log responses and handle errors
axiosInstance.interceptors.response.use(
  (response) => {
    if (__DEV__) {
      console.log('✅ [API RESPONSE]', response.status, response.config.method?.toUpperCase(), response.config.url);
      console.log('📥 [RESPONSE DATA]', JSON.stringify(response.data, null, 2));
    }
    return response;
  },
  (error) => {
    const mapped = mapAxiosError(error);
    if (__DEV__) {
      console.log('❌ [API ERROR]', mapped.code, mapped.status, mapped.message);
      if (error.response?.data) {
        console.log('📥 [ERROR RESPONSE]', JSON.stringify(error.response.data, null, 2));
      }
    }
    return Promise.reject(mapped);
  }
);

export { axiosInstance, ENDPOINTS, API_BASE_URL, RECAPTCHA_SITE_KEY };
